import { store } from '../store';
import type { Participant } from '../store/conversationSlice';
import { participantReclassified } from '../store/participantActions';
import {
  ParticipantRoleChange,
  shouldApplyRoleChange,
  snapshotRoleChanges,
} from '../utils/participantRoleChange';

/**
 * The one gate for a decision that came off a socket (utils/participantRoleChange
 * R1/R2): applied only when it is not older than the decision this app holds,
 * because the landmine and competitor slices relabel whatever the action says.
 * True when it was applied.
 */
export function applyParticipantRoleChange(change: ParticipantRoleChange): boolean {
  const held = store.getState().conversation.participantDecisions?.[change.participantId];
  if (!shouldApplyRoleChange(held, change)) {
    console.info(`[participants] Ignored an older decision about ${change.participantId}`);
    return false;
  }
  store.dispatch(participantReclassified(change));
  return true;
}

/**
 * R1/R3: a roster frame's `confirmed` entries that are decisions this app has
 * not applied (none held, or a newer `confirmedAt`: a frame missed while the
 * socket was down) are applied as decisions before the roster merge, which
 * then keeps every decided role and name. Returns how many were applied.
 */
export function applySnapshotDecisions(entries: Participant[]): number {
  const decisions = store.getState().conversation.participantDecisions ?? {};
  return snapshotRoleChanges(entries, decisions).filter(applyParticipantRoleChange).length;
}
